// components/product/ProductImage.jsx
import React from 'react';
import { FiImage } from 'react-icons/fi';

const ProductImage = ({ image, title, isDarkMode }) => {
  const [imageError, setImageError] = React.useState(false);

  return (
    <>
      {/* Mobile View - Ultra Compact */}
      <div className="block sm:hidden">
        <div className="flex items-center justify-center py-1">
          {!imageError ? (
            <img
              src={image}
              alt={title}
              className="object-contain w-24 h-24"
              onError={() => setImageError(true)}
            />
          ) : (
            <FiImage size={20} className={isDarkMode ? 'text-gray-600' : 'text-gray-300'} />
          )}
        </div>
      </div>

      {/* Desktop View - Original UI with larger image, no gray bg */}
      <div className="hidden sm:block">
        <div className="flex items-center justify-center p-8">
          {!imageError ? (
            <img
              src={image}
              alt={title}
              className="object-contain w-full max-w-lg max-h-[450px] transition-transform duration-300 hover:scale-105"
              fetchPriority="high"
              onError={() => setImageError(true)}
            />
          ) : (
            <div className="flex flex-col items-center justify-center p-8">
              <FiImage size={48} className={isDarkMode ? 'text-gray-500' : 'text-gray-400'} />
              <p className={`mt-2 text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Image not available
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductImage;